import * as PropTypes from "prop-types";

import { RS } from "../../../../data/strings/global";
import * as SC from "../../../../data/strings/PIStringConst";

import * as Theme from "../../../../app/Theme";

import * as gbtu from "../../../GB/GBTableUtil";
import * as gbtc from "../../../GB/GBTableConst";

import * as piasu from "../../NonComponents/PIAppStateUtil";

import * as pisc from "../../NonComponents/PIServerConst";
import * as pitu from "../../NonComponents/PITableUtil";

import { generateHeterogeneousTypes } from "../../../../utilities";
import SuperTableShim from "../../../common/SuperTableShim";

import { combinePriorPops, contCurveCombinedPops } from "../../NonComponents/PIPriorPopUtil";

const PIAggCostListResTable = (props) => {
  const modVarObjList = props.modVarObjList;
  /** @type {number[][][]} */
  let table = piasu.getModVarValue(modVarObjList, props.tableMVName, true);
  const isPSEMode = piasu.isPSEMode(modVarObjList);

  /** @type {any[]} */
  let priorPops = piasu.getModVarValue(modVarObjList, pisc.priorPopsMVTag);
  const methods = piasu.getModVarValue(modVarObjList, pisc.methodsMVTag);
  const selectedMethodMstID = piasu.getModVarValue(modVarObjList, pisc.selectedMethodMVTag);
  /** @type {string[]} */
  const aggFilenames = piasu.getModVarValue(modVarObjList, pisc.aggFileNamesMVTag, true);

  const selectedMethodCurrID = piasu.getMethodCurrID(methods, selectedMethodMstID);
  const numFiles = table.length;

  if (isPSEMode) {
    const combined = combinePriorPops(modVarObjList, contCurveCombinedPops, [], [props.tableMVName]);
    priorPops = combined["PI_PriorityPop"];
    table = combined[props.tableMVName];
  }

  /* Number of service delivery strategies + edu code column + personnel type column. */
  const numCols = priorPops.length + 1;

  const packTable = gbtu.resizePackTable(gbtu.getNewPackTable(), numFiles + 1, numCols);

  /* Column headings */
  gbtu.setValue(packTable, 0, 0, RS(SC.GB_stFile));

  for (let pp = 1; pp <= priorPops.length; pp++) {
    const priorPop = priorPops[pp - 1];
    gbtu.setValue(packTable, 0, pp, priorPop.name);

    for (let f = 0; f < numFiles; f++) {
      gbtu.setValue(packTable, f + 1, 0, aggFilenames[f]);
      gbtu.setValue(packTable, f + 1, pp, table[f][selectedMethodCurrID - 1][pp - 1]);
    }

    gbtu.setColWidth(packTable, pp, Theme.dataColWidthMed);
  }

  gbtu.alignNumericCellsRight(packTable);
  gbtu.setRowAlignment(packTable, 0, gbtc.hAlign.center);
  gbtu.setRDecs(packTable, 2);
  gbtu.setMinAllowedValForTable(packTable, 0);
  gbtu.setMaxAllowedValForTable(packTable, gbtc.maxInt);
  gbtu.setRowHeight(packTable, 0, 50);
  gbtu.setWordWrappedCol(packTable, 0, true);
  gbtu.lockPackTable(packTable, true, false);

  return (
    <SuperTableShim
      font={Theme.tableFont}
      headerBackgroundColor={Theme.PI_PrimaryColor}
      key={"table"}
      oddRowBackgroundColor={Theme.PI_BandColor}
      packTable={packTable}
      types={generateHeterogeneousTypes(packTable, "n")}
      onPackTableChanged={() => {}}
      removedMenuNames={pitu.tableHideMenuItems}
      style={{
        tableFont: Theme.tableFont,
        marginTop: Theme.ctrlSpacing,
        padding: 0,
      }}
    />
  );
};

PIAggCostListResTable.propTypes = {
  modVarObjList: PropTypes.array.isRequired,
  tableMVName: PropTypes.string.isRequired,
};

export default PIAggCostListResTable;
